exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-price__top-table-button {\n  margin-bottom: 16px;\n  float: right;\n}\n", ""]);

// exports
